/**
 * Build the create payload for a single-amount expense form
 * (operating expense / office equipment).
 */
export const buildExpensePayload = (form, documentType) => {
  const vatRate =
    form.vatRate === "custom"
      ? parseFloat(form.customVat) || 0
      : form.vatRate !== undefined && form.vatRate !== ""
        ? parseFloat(form.vatRate)
        : 15;

  return {
    documentType,
    vendorId: form.vendorId || null,
    vendorName: (form.vendorName || "").trim(),
    category: form.category || "",
    documentDate: form.date,
    amount: parseFloat(form.amount) || 0,
    taxRate: vatRate,
  };
};
